////////////////////////////////////////////////////
import Vue from 'vue';
import { demo } from './tradeDemo';
import { listSymbols, fetchCandles, createLiveFeed, configuredTickers } from './tiingoApi';

///////////////////////////////////////////////////

let liveFeed;
let feedStarting = false;
///////////////////////////global lets///////////////////////////////////////

let lastUpdate = Date.now() - 5000;
let closing = false;
let sockInit = false;

// Reconnect backoff now lives in the Tiingo feed (src/tiingoApi.js), which owns
// the socket and re-subscribes on its own schedule.
const app = {
    symbols: {},
    symEvents: {},
    database: {},
    users: {},
    history: {},
    controller: {},
};

//database : {1234: 'token'}

/*
symEvents = 
{
    timestamp:
    {
        userid:
        {
            symbols:[]; array of symbols id from which trigger events
        }
    }
}*/

/*
users = 
{
    userid:
    {
        sym: // ie,specific symbole id
        {
            positions: [] //array of active and closed positions
            lastPos: {timestamp: xxxx, duration: xxxx, type, price, value}
        },
        solde: 1000,
    }
}
*/

////////////////////////////////global funcs///////////////////
function putLastHistory(uid, data) {
    app.history[uid] = getNonRefObj(data);

    return;
}
function getLastHistory(uid) {
    if (!(uid in app.history)) {
        return 'empty';
    } else {
        let result = getNonRefObj(app.history[uid]);
        delete app.history[uid];
        return result;
    }
}
// Resolves the tracked symbol list over REST, then opens the live tick feed.
// Tiingo lists thousands of pairs, so we register only the configured tickers
// rather than everything the exchange offers.
async function reinitConnexion() {
    if (closing || feedStarting) {
        return;
    }
    feedStarting = true;

    const tickers = configuredTickers();
    try {
        const catalog = await listSymbols();
        const nameByTicker = {};
        catalog.forEach((el) => {
            nameByTicker[el['symbol']] = el['display_name'];
        });
        tickers.forEach((ticker) => {
            if (!(ticker in app.symbols)) {
                app.symbols[ticker] = {
                    name: nameByTicker[ticker] || String(ticker).toUpperCase(),
                    price: 0,
                    updated_at: 0,
                    candle: [],
                };
            }
        });
    } catch (err) {
        // Symbol metadata is cosmetic: fall back to bare tickers so the feed
        // still starts if the REST catalog call fails.
        tickers.forEach((ticker) => {
            if (!(ticker in app.symbols)) {
                app.symbols[ticker] = {
                    name: String(ticker).toUpperCase(),
                    price: 0,
                    updated_at: 0,
                    candle: [],
                };
            }
        });
    }

    if (liveFeed == undefined) {
        liveFeed = createLiveFeed({
            tickers: tickers,
            granularities: [60],
            onOhlc: handleFeedMessage,
            onFatal: function (err) {
                // A rejected token never recovers, so stop instead of retrying.
                closing = true;
                console.error('[tiingo]', err.message);
            },
        });
        liveFeed.start();
    } else {
        liveFeed.setTickers(tickers);
    }

    sockInit = false;
    feedStarting = false;
}

// Receives each aggregated candle update from the Tiingo tick stream, in the
// same shape the old Deriv 'ohlc' message had.
function handleFeedMessage(data) {
        if (data['msg_type'] == 'ohlc') {
            sockInit = false;
            lastUpdate = Date.now();
            // The shared feed owns the reconnect backoff and resets it itself.
            const symbol = data['ohlc']['symbol'];
            const epoch = data['ohlc']['open_time'];
            const open = data['ohlc']['open'];
            const close = data['ohlc']['close'];
            const high = data['ohlc']['high'];
            const low = data['ohlc']['low'];

            if (symbol in app.symbols) {
                const oldPrice = app.symbols[`${symbol}`]['price'];

                app.symbols[`${symbol}`]['price'] = close;
                app.symbols[`${symbol}`]['updated_at'] = Date.now();
                app.symbols[`${symbol}`]['candle'] = [
                    {
                        epoch: epoch,
                        open: open,
                        close: close,
                        high: high,
                        low: low,
                    },
                ];
                for (const uid in app.users) {
                    if (Object.hasOwnProperty.call(app.users, uid)) {
                        if (symbol in app.users[uid]) {
                            if ('lastPos' in app.users[uid][symbol]) {
                                let type = app.users[uid][symbol].lastPos.type;
                                if (type == 'pending-buy' || type == 'pending-sell') {
                                    let price = app.users[uid][symbol].lastPos.price;
                                    let value = app.users[uid][symbol].lastPos.value;
                                    let duration = app.users[uid][symbol].lastPos.duration;
                                    if (price <= close && oldPrice <= price) {
                                        takePos(
                                            symbol,
                                            60,
                                            2,
                                            0,
                                            String(type).replace('pending-', ''),
                                            uid,
                                            app.database[uid]['token'],
                                            value,
                                            duration
                                        );
                                    } else if (price >= close && oldPrice >= price) {
                                        takePos(
                                            symbol,
                                            60,
                                            2,
                                            0,
                                            String(type).replace('pending-', ''),
                                            uid,
                                            app.database[uid]['token'],
                                            value,
                                            duration
                                        );
                                    }
                                }
                            }
                        }
                    }
                }
                const data = {
                    name: app.symbols[`${symbol}`]['name'],
                    symbole: symbol,
                    price: close,
                    candle: [
                        {
                            epoch: epoch,
                            open: open,
                            close: close,
                            high: high,
                            low: low,
                        },
                    ],
                    secret: '$2y$10$y0cudLALEw3JrqcIVlNHt.zWIcCj9FByLrBSu2O0hPSC9p4KsHE4q',
                };
                demo.controller
                    .updateprice({ body: { data: JSON.stringify(data) } })

                    .then((res) => {
                        return;
                    })
                    .catch((err) => {
                        return;
                    });
            }
        }
}

function addSymEvent(ts, uid, data) {
    if (!(ts in app.symEvents)) {
        app.symEvents[ts] = {};
    }
    if (!(uid in app.symEvents[ts])) {
        app.symEvents[ts][uid] = {};
    }
    if (!('symbols' in app.symEvents[ts][uid])) {
        app.symEvents[ts][uid]['symbols'] = [];
    }

    app.symEvents[ts][uid]['symbols'].push(data);
}
function removeSymEvent(ts, uid, data) {
    if (app.symEvents[ts][uid]['symbols']) {
        let id = app.symEvents[ts][uid]['symbols'].indexOf(data);
        if (id > -1) {
            app.symEvents[ts][uid]['symbols'].splice(id, 1);
            // // console.log('event removed', app.symEvents[ts][uid]);
        }
        if (app.symEvents[ts][uid]['symbols'].length < 1) {
            delete app.symEvents[ts][uid];
        }
    }
}
async function fireSymEvent(ts, uid, sym) {
    return new Promise((resolve, reject) => {
        if (!(uid in app.users)) {
            resolve('not found');
        }
        if (!(sym in app.users[uid])) {
            resolve('not found');
        }
        if (!('positions' in app.users[uid][sym])) {
            resolve('not found');
        }
        if (!(uid in app.users)) {
            resolve('not found');
        }
        if (!(sym in app.users[uid])) {
            resolve('not found');
        }
        if (!('positions' in app.users[uid][sym])) {
            resolve('not found');
        }
        const val = app.users[uid][sym].positions[app.users[uid][sym].positions.length - 1][3];

        takePos(
            sym,
            60,
            2,
            0,
            'close',
            uid,
            '$2y$10$y0cudLALEw3JrqcIVlNHt.zWIcCj9FByLrBSu2O0hPSC9p4KsHE4q',
            val,
            0
        ).then(
            (res) => {
                if (res != 'error') {
                    for (let i = 0; i < app.users[uid][sym].positions.length; i++) {
                        const type = app.users[uid][sym].positions[i][1];
                        app.users[uid][sym].positions[i][1] = type == 0 ? 4 : type == 1 ? 5 : type;
                    }
                    resolve('done');
                } else {
                    resolve('error');
                }
            },
            (err) => {
                resolve('error');
            }
        );
    });
}
async function watchSymEvents(count) {
    try {
        let now = Date.now();
        if (now - lastUpdate > 5000) {
            if (!sockInit || now - lastUpdate > 50000) {
                reinitConnexion();
            }
            // console.log('API lost');
        }

        for (const ts in app.symEvents) {
            if (Object.hasOwnProperty.call(app.symEvents, ts)) {
                if (Number(ts) < Date.now()) {
                    let len = 0;
                    for (const uid in app.symEvents[ts]) {
                        if (Object.hasOwnProperty.call(app.symEvents[ts], uid)) {
                            len += 1;
                            for (
                                let i = 0;
                                ts in app.symEvents &&
                                uid in app.symEvents[ts] &&
                                'symbols' in app.symEvents[ts][uid] &&
                                i < app.symEvents[ts][uid]['symbols'].length;
                                i++
                            ) {
                                if (!(ts in app.symEvents)) {
                                    break;
                                }
                                if (!(uid in app.symEvents[ts])) {
                                    break;
                                }
                                if (!('symbols' in app.symEvents[ts][uid])) {
                                    break;
                                }
                                if (app.symEvents[ts][uid]['symbols'][i]) {
                                    const data = app.symEvents[ts][uid]['symbols'][i];
                                    removeSymEvent(ts, uid, data);
                                    i--;
                                    fireSymEvent(ts, uid, data).then((res) => {
                                        if (res == 'done') {
                                            // console.log('fired event :', ts, uid, data);
                                        } else if (res == 'error') {
                                            // console.log('unable to fire event :', ts, uid, data);
                                            addSymEvent(ts, uid, data);
                                        }
                                    });
                                }
                            }
                        }
                    }
                    if (len < 1) {
                        delete app.symEvents[ts];
                    }
                }
            }
        }
    } catch (err) {
        // console.log(err);
    } finally {
        setTimeout(() => {
            // Tiingo sends its own heartbeats, so no client-side keepalive.
            watchSymEvents(count + 1);
        }, 2000);
    }
}

function populateData(candles) {
    const result = [];
    for (let i = 0; i < candles.length; i++) {
        result.push([
            candles[i]['epoch'] * 1000,
            candles[i]['open'],
            candles[i]['high'],
            candles[i]['low'],
            candles[i]['close'],
            0,
        ]);
    }

    return result;
}
// How stale the streamed price may be before a position falls back to a REST
// bar. Prefer the live price generously: the fallback costs an API request
// against the hourly budget *and* its newest bar can itself be a full bar old,
// so it is worse on both counts.
const LIVE_PRICE_MAX_AGE_MS = 10000;

// The stored candle carries the bar's open_time, which at 60s granularity sits
// up to a minute behind the tick that actually filled the position. populatePos
// reads that value for both the chart marker and the expiry it derives from it,
// so stamp the entry at the real moment instead.
function liveEntryCandle(symbole) {
    const candles = getNonRefObj([...app.symbols[symbole]['candle']]);
    if (candles.length) {
        candles[candles.length - 1]['epoch'] = Math.floor(Date.now() / 1000);
    }
    return candles;
}

async function populatePos(candles, symbol, type, uid, token, value, duration) {
    return new Promise((resolve, reject) => {
        // console.log('position :', type, 'value ', value);
        let data = [];
        let result = [];
        let solde = getSolde(uid, token);
        if (solde != -1) {
            if ((type == 'buy' || type == 'sell') && solde < value) {
                return 'error';
            }
            const win = Number(value * 0.85);
            const loss = Number(value);
            let gain = 0;
            let shift = 0;

            let isNew = false;
            for (let i = 0; i < candles.length; i++) {
                data.push([
                    candles[i]['epoch'] * 1000,
                    candles[i]['open'],
                    candles[i]['high'],
                    candles[i]['low'],
                    candles[i]['close'],
                    0,
                ]);
            }
            if (!(uid in app.users)) {
                app.users[uid] = {};
                isNew = true;
            }
            if (!(symbol in app.users[uid])) {
                app.users[uid][symbol] = {};
                isNew = true;
            }
            if (!('lastPos' in app.users[uid][symbol])) {
                app.users[uid][symbol].lastPos = { timestamp: 0 };
            }

            if ((type == 'close' || type == 'leave') && !isNew && app.users[uid][symbol].positions.length) {
                const current = data[data.length - 1][4];
                const prev = app.users[uid][symbol].positions[app.users[uid][symbol].positions.length - 1][2];
                const ptype = app.users[uid][symbol].positions[app.users[uid][symbol].positions.length - 1][1];
                if (type == 'close') {
                    if (ptype == 0) {
                        if (prev > current) {
                            solde = solde + Number(value) + win;
                            gain = win;
                        } else {
                            gain = -loss;
                        }
                    } else if (ptype == 1) {
                        if (prev < current) {
                            solde = solde + Number(value) + win;
                            gain = win;
                        } else {
                            gain = -loss;
                        }
                    }
                } else {
                    if (ptype == 0) {
                        if (prev > current) {
                            gain = -loss;
                        } else {
                            solde = solde + Number(value) / 3;
                            gain = (-loss * 2) / 3;
                        }
                    } else if (ptype == 1) {
                        if (prev < current) {
                            gain = -loss;
                        } else {
                            solde = solde + Number(value) / 3;
                            gain = (-loss * 2) / 3;
                        }
                    }
                    for (let i = 0; i < app.users[uid][symbol].positions.length; i++) {
                        const type = app.users[uid][symbol].positions[i][1];
                        app.users[uid][symbol].positions[i][1] = type == 0 ? 4 : type == 1 ? 5 : type;
                    }
                }

                putLastHistory(uid, {
                    symbol: app.symbols[symbol].name,
                    type: ptype == 1 ? 'Buy' : ptype == 0 ? 'Sell' : '',
                    gain: gain,
                });
                setSolde(uid, token, solde);
            } else {
                solde -= Number(value);

                setSolde(uid, token, solde);
            }
            const now = Date.now();
            if (type == 'buy' || type == 'sell') {
                addSymEvent(now + duration, uid, symbol);
            }
            app.users[uid][symbol].lastPos = {
                timestamp: now,
                duration: duration,
                type: type == 'leave' ? 'close' : type,
                price: data[data.length - 1][4],
                value: (type == 'leave' || type == 'close') && gain != 0 ? gain : value,
            };

            if (app.users[uid][symbol].positions.length > 0) {
                const prev = app.users[uid][symbol].positions[app.users[uid][symbol].positions.length - 1][0];
                if (data[data.length - 1][0] == prev) {
                    shift = 5;
                }
            }
            const newPosition = [
                data[data.length - 1][0] + shift,
                type == 'buy' ? 1 : type == 'sell' ? 0 : 3,
                data[data.length - 1][4],
                (type == 'close' || type == 'leave') && gain != 0 ? gain : value,
                Number(data[data.length - 1][0]) + duration,
            ];
            app.users[uid][symbol].positions.push(newPosition);

            result.push([
                data[data.length - 1][0] + shift,
                type == 'buy' ? 1 : type == 'sell' ? 0 : 3,
                data[data.length - 1][4],
                value,
                Number(data[data.length - 1][0]) + duration,
            ]);
            resolve(result);
        } else {
            resolve('error');
        }
    });
}

async function getHistory(symbole, tf, count, endArg) {
    // Tiingo serves history over REST, so the old one-shot socket is gone.
    const candles = await fetchCandles(symbole, tf, count, endArg);
    return populateData(candles);
}
async function takePos(symbole, tf, count, endArg, type, uid, token, value, duration) {
    return new Promise((resolve, reject) => {
        try {
            const sold = getSolde(uid, token);
            if ((type.indexOf('buy') != -1 || type.indexOf('sell') != -1) && sold < value) {
                resolve('error');
            }
            let fast = true;
            if (!(symbole in app.symbols)) {
                fast = false;
            } else if (Date.now() - app.symbols[symbole]['updated_at'] > LIVE_PRICE_MAX_AGE_MS) {
                fast = false;
            }
            if (fast) {
                // console.log('fast positioning');
                populatePos(
                    liveEntryCandle(symbole),
                    symbole,
                    type,
                    uid,
                    token,
                    value,
                    duration
                ).then((result) => {
                    resolve(result);
                });
            } else {
                fetchCandles(symbole, tf, count, endArg)
                    .then((candles) => {
                        populatePos(candles, symbole, type, uid, token, value, duration).then((result) => {
                            resolve(result);
                        });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            }
        } catch (error) {
            reject(error);
        }
    });
}
async function takePendingPos(symbole, tf, count, endArg, type, uid, token, price, value, duration) {
    return new Promise((resolve, reject) => {
        try {
            const sold = getSolde(uid, token);
            if (!(uid in app.users)) {
                resolve('error');
            } else if (sold < value) {
                resolve('error');
            } else {
                if (!(symbole in app.users[uid])) {
                    app.users[uid][symbole] = {
                        positions: [],
                        lastPos: {
                            timestamp: Date.now(),
                            duration: duration,
                            type: `pending-${type}`,
                            price: price,
                            value: value,
                        },
                    };
                } else {
                    app.users[uid][symbole].lastPos = {
                        timestamp: Date.now(),
                        duration: duration,
                        type: `pending-${type}`,
                        price: price,
                        value: value,
                    };
                }
            }
        } catch (error) {
            reject(error);
        }
    });
}
function getAllPos(uid) {
    if (!(uid in app.users)) {
        return 'empty';
    }
    let result = [];
    for (const sym in app.users[uid]) {
        if (Object.hasOwnProperty.call(app.users[uid], sym)) {
            if ('lastPos' in app.users[uid][sym]) {
                let left = -1;
                if ('timestamp' in app.users[uid][sym].lastPos) {
                    if (app.users[uid][sym].lastPos['timestamp'] != 0) {
                        left =
                            app.users[uid][sym].lastPos['timestamp'] +
                            app.users[uid][sym].lastPos['duration'] -
                            Date.now();
                    }
                }
                const data = { ...app.users[uid][sym].lastPos, left: (left > -3 ? left : -3) + 3, symbol: sym };
                result.push(data);
            }
        }
    }
    if (result.length < 1) {
        return 'empty';
    }
    return getNonRefObj(result);
}
function getLastPos(uid, sym) {
    if (!(uid in app.users)) {
        return 'empty';
    }
    if (!(sym in app.users[uid])) {
        return 'empty';
    }
    if (!('lastPos' in app.users[uid][sym])) {
        return 'empty';
    }
    let left = -3;
    if ('timestamp' in app.users[uid][sym].lastPos && app.users[uid][sym].lastPos['type'] != 'close') {
        if (app.users[uid][sym].lastPos['timestamp'] != 0) {
            left = app.users[uid][sym].lastPos['timestamp'] + app.users[uid][sym].lastPos['duration'] - Date.now();
        }
    }
    return { ...app.users[uid][sym].lastPos, left: (left > -3 ? left : -3) + 3 };
}
function getSolde(uid, token) {
    let isInData = false;
    let isSolded = false;
    if (uid in app.database) {
        isInData = true;
        if ('solde' in app.database[uid]) {
            isSolded = true;
        }
    }

    if (!isInData) {
        return -1;
    } else if (!isSolded) {
        return -1;
    } else if (isInData && isSolded) {
        return Number(app.database[uid]['solde']);
    }
}

async function setSolde(uid, token, value) {
    const solde = Number(value);
    ///
}
async function control(uid, token) {
    //// console.log('control ', uid, token);
    return new Promise((resolve, reject) => {
        if (!(uid in app.database)) {
            mkLogin(uid, token);
        } else if (!('token' in app.database[uid])) {
            mkLogin(uid, token);
        } else if (app.database[uid]['token'] != token) {
            mkLogin(uid, token);
        }
        resolve('authenticated');
    });
    function mkLogin(id, token, solde = 1000) {
        app.database[id] = {
            token: token,
            solde: solde,
        };
        const data = {
            id: reqdata.id,
            token: reqdata.token,
            secret: '$2y$10$y0cudLALEw3JrqcIVlNHt.zWIcCj9FByLrBSu2O0hPSC9p4KsHE4q',
        };
    }
}

watchSymEvents(0);
// console.log('Watching 👁️');

function getNonRefObj(obj) {
    const _ = JSON.stringify(obj);
    return JSON.parse(_);
}
///////////////////////////////////////////////////////////////

app.controller.userlogin = async (req) => {
    return new Promise((res, rej) => {
        const reqdata = JSON.parse(req.body.data);
        // console.log('user login');
        // console.log('data = ', reqdata);

        if (reqdata.secret == '$2y$10$y0cudLALEw3JrqcIVlNHt.zWIcCj9FByLrBSu2O0hPSC9p4KsHE4q') {
            app.database[reqdata.id] = {
                token: reqdata.token,
                solde: reqdata.solde,
            };
            const data = {
                id: reqdata.id,
                token: reqdata.token,
                secret: '$2y$10$y0cudLALEw3JrqcIVlNHt.zWIcCj9FByLrBSu2O0hPSC9p4KsHE4q',
            };

            demo.controller
                .userlogin({ body: { data: JSON.stringify(data) } })

                .then((r) => {
                    // console.log('Logged in');
                    res({
                        status: 200,
                        data: reqdata,
                    });
                    return;
                })
                .catch((err) => {
                    // console.log(err, 'Error loggin in');
                    res({
                        status: 200,
                        data: 'done',
                    });
                    return;
                });
        } else {
            // console.log('Secret mismatch', reqdata.secret);
            res({
                status: 200,
                data: 'done',
            });
            return;
        }
    });
};
app.controller.soldeupdate = async (req) => {
    return new Promise((res, rej) => {
        const reqdata = JSON.parse(req.body.data);
        if (reqdata.secret == '$2y$10$y0cudLALEw3JrqcIVlNHt.zWIcCj9FByLrBSu2O0hPSC9p4KsHE4q') {
            if (!(reqdata.id in app.database)) {
                res(200);
                return;
            } else {
                /* console.log(
                    'sold updated for ',
                    reqdata.id,
                    ' from ',
                    app.database[reqdata.id]['solde'],
                    ' to ',
                    reqdata.solde
                ); */
                app.database[reqdata.id]['solde'] = reqdata.solde;
                res({
                    status: 200,
                    data: null,
                });
                return;
            }
        } else {
            res({
                status: 200,
                data: null,
            });
            return;
        }
    });
};

////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////

app.controller.history = async (req) => {
    return new Promise((res, rej) => {
        const reqdata = JSON.parse(req.body.data);
        const start = new Date();

        try {
            getHistory(reqdata.symbole, reqdata.tf, reqdata.count, reqdata.end)
                .then((data) => {
                    if (data != 'error') {
                        const end = new Date();
                        // console.log('sent history : in ', end - start, 'ms');

                        res({
                            status: 200,
                            data: { symbole: reqdata.symbole, data: data },
                        });
                    } else {
                        res({
                            status: 400,
                            data: data,
                        });
                    }
                })
                .catch((err) => {
                    // console.log(err);
                    rej(err);
                });
        } catch (err) {
            rej(`${err.message}`);
        }
        return;
    });
};
app.controller.ping = async (req) => {
    const reqdata = JSON.parse(req.body.data);
    const r = await control(reqdata.userid, reqdata.token);
    return new Promise((res, rej) => {
        //// console.log('ping');

        if (r == 'authenticated') {
            //// console.log('middleware pass');
        } else {
            res({
                status: 401,
                data: null,
            });
            return;
        }

        try {
            const solde = getSolde(reqdata.userid, reqdata.token);
            if (!(reqdata.userid in app.users)) {
                app.users[reqdata.userid] = {};
            }
            const otherPos = getAllPos(reqdata.userid);
            const lastHistory = getLastHistory(reqdata.userid);
            if (!(reqdata.symbole in app.users[reqdata.userid])) {
                app.users[reqdata.userid][reqdata.symbole] = {
                    positions: [],
                };
            }

            const lastPosition = getLastPos(reqdata.userid, reqdata.symbole);
            if (app.users[reqdata.userid][reqdata.symbole].positions) {
                const positionsData = getNonRefObj(app.users[reqdata.userid][reqdata.symbole].positions);

                if (positionsData.length > 0) {
                    res({
                        status: 200,
                        data: {
                            symbole: reqdata.symbole,
                            data: [...positionsData],
                            lastPosition: lastPosition,
                            otherPositions: otherPos,
                            solde: solde,
                            lastHistory: lastHistory,
                        },
                    });
                } else {
                    res({
                        status: 200,
                        data: {
                            symbole: reqdata.symbole,
                            data: 'empty',
                            lastPosition: lastPosition,
                            otherPositions: otherPos,
                            solde: solde,
                            lastHistory: lastHistory,
                        },
                    });
                }
            } else {
                res({
                    status: 200,
                    data: {
                        symbole: reqdata.symbole,
                        data: 'empty',
                        lastPosition: lastPosition,
                        otherPositions: otherPos,
                        solde: solde,
                        lastHistory: lastHistory,
                    },
                });
            }
        } catch (err) {
            rej(`${err.message}`);
        }
        return;
    });
};
app.controller.takeposition = async (req) => {
    return new Promise((res, rej) => {
        const reqdata = JSON.parse(req.body.data);
        const start = new Date();

        try {
            const sold = getSolde(reqdata.userid, reqdata.token);
            const lastPos = getLastPos(reqdata.userid, reqdata.symbole);
            const allow = lastPos == 'empty' ? true : lastPos['type'] == 'close' ? true : false;
            if (sold > reqdata.value && allow) {
                takePos(
                    reqdata.symbole,
                    60,
                    2,
                    0,
                    reqdata.type,
                    reqdata.userid,
                    reqdata.token,
                    reqdata.value,
                    reqdata.duration
                )
                    .then((data) => {
                        if (data != 'error') {
                            const end = new Date();
                            // console.log('pos ', reqdata.type, ' taken in ', end - start, 'ms');
                            res({
                                status: 200,
                                data: { symbole: reqdata.symbole, data: data },
                            });
                        } else {
                            rej(data);
                        }
                    })
                    .catch((err) => {
                        // console.log(err);
                        rej(err);
                    });
            } else {
                if (!allow) {
                    res({
                        status: 200,
                        data: { symbole: reqdata.symbole, data: 'Position en cours' },
                    });
                } else {
                    res({
                        status: 200,
                        data: { symbole: reqdata.symbole, data: 'Solde épuisé' },
                    });
                }
            }
        } catch (err) {
            rej(`${err.message}`);
        }
        return;
    });
};
app.controller.pendingposition = async (req) => {
    return new Promise((res, rej) => {
        const reqdata = JSON.parse(req.body.data);
        const start = new Date();
        // console.log('pending position : ', start.toDateString(), ' - ', reqdata);
        try {
            const sold = getSolde(reqdata.userid, reqdata.token);
            const lastPos = getLastPos(reqdata.userid, reqdata.symbole);
            const allow = lastPos == 'empty' ? true : lastPos['type'] == 'close' ? true : false;
            if (sold > reqdata.value && allow) {
                takePendingPos(
                    reqdata.symbole,
                    60,
                    2,
                    0,
                    reqdata.type,
                    reqdata.userid,
                    reqdata.token,
                    reqdata.price,
                    reqdata.value,
                    reqdata.duration
                )
                    .then((data) => {
                        if (data != 'error') {
                            const end = new Date();
                            // console.log('pos ', reqdata.type, ' taken in ', end - start, 'ms');
                            res({
                                status: 200,
                                data: { symbole: reqdata.symbole, data: 'done' },
                            });
                        } else {
                            rej(data);
                        }
                    })
                    .catch((err) => {
                        // console.log(err);
                        rej(err);
                    });
            } else {
                if (!allow) {
                    res({
                        status: 201,
                        data: { symbole: reqdata.symbole, data: 'Position en cours' },
                    });
                } else {
                    res({
                        status: 201,
                        data: { symbole: reqdata.symbole, data: 'Solde épuisé' },
                    });
                }
            }
        } catch (err) {
            rej(`${err.message}`);
        }
        return;
    });
};
app.controller.closepending = async (req) => {
    return new Promise((res, rej) => {
        const reqdata = JSON.parse(req.body.data);
        const start = new Date();
        // console.log('pending position : ', start.toDateString(), ' - ', reqdata);
        try {
            const uid = reqdata.userid;
            const symbole = reqdata.symbole;
            if (!(uid in app.users)) {
                res({
                    status: 401,
                    data: `Unauthorized query`,
                });
                return;
            } else if (!(symbole in app.users[uid])) {
                res({
                    status: 400,
                    data: `Symbol position not found`,
                });
                return;
            } else if (!('lastPos' in app.users[uid][symbole])) {
                res({
                    status: 400,
                    data: `Last position not found`,
                });
                return;
            } else if (
                !(
                    app.users[uid][symbole].lastPos.type == 'pending-buy' ||
                    app.users[uid][symbole].lastPos.type == 'pending-sell'
                )
            ) {
                res({
                    status: 400,
                    data: `Position not found`,
                });
                return;
            } else {
                app.users[uid][symbole].lastPos = {
                    timestamp: Date.now(),
                    duration: 0,
                    type: `close`,
                    price: 0,
                    value: 0,
                };
                res({
                    status: 200,
                    data: `Done`,
                });
            }
        } catch (err) {
            rej(`${err.message}`);
        }
        return;
    });
};
app.controller.closeposition = async (req) => {
    return new Promise((res, rej) => {
        const reqdata = JSON.parse(req.body.data);
        const start = new Date();
        // console.log('close position : ', start.toDateString(), ' - ', reqdata);
        try {
            const lastPos = getLastPos(reqdata.userid, reqdata.symbole);
            const allow = lastPos == 'empty' ? false : lastPos['type'] == 'close' ? false : true;
            if (allow) {
                removeSymEvent(reqdata.timestamp + reqdata.duration, reqdata.userid, reqdata.symbole);
                takePos(
                    reqdata.symbole,
                    60,
                    2,
                    0,
                    reqdata.type,
                    reqdata.userid,
                    reqdata.token,
                    reqdata.value,
                    reqdata.duration
                )
                    .then((data) => {
                        if (data != 'error') {
                            const end = new Date();
                            // console.log('pos ', reqdata.type, ' closed in ', end - start, 'ms');
                            res({
                                status: 200,
                                data: { symbole: reqdata.symbole, data: data },
                            });
                        } else {
                            res({
                                status: 400,
                                data: data,
                            });
                            addSymEvent(reqdata.timestamp + reqdata.duration, reqdata.userid, reqdata.symbole);
                        }
                    })
                    .catch((err) => {
                        // console.log(err);
                        addSymEvent(reqdata.timestamp + reqdata.duration, reqdata.userid, reqdata.symbole);
                        rej(err);
                    });
            } else {
                res({
                    status: 200,
                    data: { symbole: reqdata.symbole, data: 'Pas de position en cours' },
                });
            }
        } catch (err) {
            rej(`${err.message}`);
        }
        return;
    });
};
export const core = Vue.observable(app);
